export default "__VITE_ASSET__GsnQWUDT__"